import styled from '@emotion/styled';

export const AlertWrapper = styled('div', { label: 'AlertWrapper' })`
    margin-bottom: 16px;
`;
